function sorguDizgesi(s) {
    const p = new URLSearchParams();
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    if (s.arama)
        p.set('arama', s.arama);
    if (s.aktif !== undefined)
        p.set('aktif', String(s.aktif));
    if (s.tip)
        p.set('tip', s.tip);
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function kuponlariListele(istemci, sorgu = {}) {
    return istemci.istek(`/kuponlar${sorguDizgesi(sorgu)}`);
}
export async function kuponGetir(istemci, id) {
    return istemci.istek(`/kuponlar/${id}`);
}
export async function kuponKullanimlari(istemci, id) {
    return istemci.istek(`/kuponlar/${id}/kullanimlar`);
}
export async function kuponOlustur(istemci, giris) {
    return istemci.istek('/kuponlar', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function kuponGuncelle(istemci, id, giris) {
    return istemci.istek(`/kuponlar/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(giris),
    });
}
export async function kuponSil(istemci, id) {
    return istemci.istek(`/kuponlar/${id}`, { method: 'DELETE' });
}
//# sourceMappingURL=kuponlar.js.map